import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import FarmCreatePageContentDesktop from './ContentDesktop';
import FarmCreatePageContentMobile from './ContentMobile';

interface FarmCreatePageContentProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const Content = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: FarmCreatePageContentProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const props = {
    handleSubmitStep,
    handleNextStep,
    ListStep,
    isSubmitting,
    currentTab,
    handleChangeCurrentStep,
  };
  const renderElements = {
    [DEVICES.DESKTOP]: <FarmCreatePageContentDesktop {...props} />,
    [DEVICES.MOBILE]: <FarmCreatePageContentMobile {...props} />,
    [DEVICES.TABLET]: <FarmCreatePageContentMobile {...props} />,
  };
  return renderElements[appDevice.device];
};

export default Content;
